<template lang="pug">
  .books-settings
    v-container.white.px-6(style="max-width:600px")
      v-layout.my-2
        div.mr-2
          v-icon.mt-1(left color="black" :size="24" @click="$router.push('/admin/settings')") mdi-arrow-left
        div.title.font-weight-bold {{ $t('books_settings') }}

      .content.mt-6
        v-card.pa-6.mt-2(flat outlined :ripple="false" @click="showImportDataDialog = true")
          v-layout
            .h6.textColorAccent--text {{ $t('import_data') }}
            v-layout.ml-1(style="max-width:24px; height:24px")
              eva-icon.ma-auto(name="chevron-right-outline" :fill="$vuetify.theme.themes[$theme].textColorAccent")
          .p2.primary400--text {{ $t('import_existing_data_from') }}
        
        //- v-card.pa-6.mt-4(flat outlined)
        //-   v-layout
        //-     .h6.textColorAccent--text Export data
        //-     v-layout.ml-1(style="max-width:24px; height:24px")
        //-       eva-icon.ma-auto(name="chevron-right-outline" :fill="$vuetify.theme.themes[$theme].textColorAccent")
        //-   .p2.primary400--text Download and export your company’s data
    
    .modals
      ImportDataDialog(v-if="showImportDataDialog" :open.sync="showImportDataDialog")

</template>

<script>
import ImportDataDialog from '@/components/yezzabook/dialogs/ImportDataDialog.vue'

export default {
  name: 'BooksSettings',
  components: { ImportDataDialog },
  data () {
    return {
      showImportDataDialog: false
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style scoped>
</style>

<i18n>
{
  "en": {
    "books_settings": "Books Settings",
    "import_data": "Import data",
    "import_existing_data_from": "Import existing data from your previous accounting system into Books"
  },
  "id": {
  }
}
</i18n>